import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const ossTokenKey = 'Oss-Token' 
export function getOssToken() {
  return sessionStorage.getItem(ossTokenKey);
}

export function setOssToken(token) {
  return sessionStorage.setItem(ossTokenKey, token);
}

export function removeOssToken() {
  return sessionStorage.removeItem(ossTokenKey);
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js